import { StatePropertyRef } from './ExtendableStore';

export interface MyProfileInfo {
    id: string;
    email: string;
    name: string;
}

export const MyProfileInfo = StatePropertyRef<MyProfileInfo>('profile');
